// extracted by mini-css-extract-plugin
module.exports = {"section":"components-Section-section-f7df82de","headline":"components-Section-headline-aafd7fff"};